/* eslint-disable */
/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import jwtDecode from 'jwt-decode'

import logger from '../../../../logger'

export interface AssetProvider {
  length: number
  uri: string
  descriptor: string
}

export default class Store {
  prefix: string
  serverAddress?: string
  APPID?: string
  wssocketAddress: string[]
  accessToken: string | null
  privateRefreshToken: string | null
  privateAssetProvider: AssetProvider[] | null

  constructor(prefix: string) {
    this.prefix = prefix

    this.accessToken = null
    this.privateRefreshToken = null
    this.privateAssetProvider = null

    this.wssocketAddress = []
  }

  get server() {
    return this.serverAddress
  }

  set server(address) {
    this.serverAddress = address
  }

  set userID(userid) {
    // this.USERID = userid
  }

  get userID(): string | null {
    try {
      const token = this.refreshToken
      if (token) {
        const dCode: any = jwtDecode(token)
        return dCode.user_id || dCode.sub
      } else {
        return null
      }
    } catch (err) {
      logger.warn('Decoding failed!')
      return null
    }
  }

  get appID() {
    return this.APPID
  }

  set appID(appid) {
    this.APPID = appid
  }

  get websocketAddress() {
    return this.wssocketAddress
  }

  set websocketAddress(websocAddress) {
    this.wssocketAddress = websocAddress
  }

  set token(token: string | null) {
    this.accessToken = token
  }

  get token(): string | null {
    return this.accessToken
  }

  set refreshToken(refresh: string | null) {
    this.token = ''
    this.privateRefreshToken = refresh
    if (typeof localStorage !== 'undefined') {
      if (refresh) localStorage.setItem(`${this.prefix}_refresh`, refresh)
      else localStorage.removeItem(`${this.prefix}_refresh`)
    }
  }

  get refreshToken(): string | null {
    if (this.privateRefreshToken) {
      return this.privateRefreshToken
    }
    if (typeof localStorage !== 'undefined') {
      // eslint-disable-next-line no-undef
      const rT = localStorage.getItem(`${this.prefix}_refresh`)
      if (rT) {
        return rT
      }
    }
    return null
  }

  set assetProvider(provider: AssetProvider[]) {
    this.privateAssetProvider = provider
    if (typeof localStorage !== 'undefined') {
      // eslint-disable-next-line no-undef
      localStorage.setItem(`${this.prefix}_asset_provider`, JSON.stringify(provider))
    }
  }

  get assetProvider(): AssetProvider[] {
    if (this.privateAssetProvider) {
      return this.privateAssetProvider
    }
    if (typeof localStorage !== 'undefined') {
      // eslint-disable-next-line no-undef
      try {
        const assetProvider = localStorage.getItem(`${this.prefix}_asset_provider`)
        if (assetProvider) return JSON.parse(assetProvider)
        else return []
      } catch (err) {
        logger.warn('Unable to parse JSON payload ', err)
      }
    }
    return []
  }
}
